import { createAsyncThunk } from '@reduxjs/toolkit';
import { type ValidateOfferCodeRequest } from '@sparrow-card/sparrow-card-constants';
import type OfferCodeApi from 'api/digifi/application/OfferCodeApi';
import { ActionType } from 'enums/ActionType';

export const createValidateOfferCodeThunk = (api: OfferCodeApi) => {
  return createAsyncThunk(ActionType.ValidateOfferCode, async (data: ValidateOfferCodeRequest) => {
    return await api.validateOfferCode(data);
  });
};
